import React, {
    Component,
} from 'react';

import {
    Waypoint,
} from 'react-waypoint';

import {
    SectionTitle,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

import BOOKING_IMAGE from 'wanderu-assets/images/booking.png';

import TwoColumnLayout, {
    LeftColumn,
    RightColumn,
} from '../TwoColumnLayout/TwoColumnLayout';

import styles from './BookSection.scss';

class BookSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
        };
    }

    onEnterWaypoint = () => {
        this.setState(() => ({
            visible: true,
        }));
    }

    render() {
        const {
            t,
            className,
        } = this.props;
        const {
            visible,
        } = this.state;
        const imageClass = `${styles.bookImage} ${visible
            ? styles.visible
            : ''}`;

        return (
            <section
                aria-labelledby="gta-book"
                className={className}
                role="region"
            >
                <TwoColumnLayout layoutClassName={styles.bookSection}>
                    <LeftColumn className={styles.leftColumn}>
                        <div className={styles.leftColumnContent}>
                            <SectionTitle
                                className={styles.title}
                                id="gta-book"
                            >
                                {t('Book')}
                            </SectionTitle>
                            <p className={styles.text}>
                                {t('book-section-text')}
                            </p>
                        </div>
                    </LeftColumn>
                    <RightColumn className={styles.rightColumn}>
                        <img
                            alt={t('Book')}
                            className={imageClass}
                            height="335"
                            src={BOOKING_IMAGE}
                            width="335"
                        />
                    </RightColumn>
                </TwoColumnLayout>
                <Waypoint onEnter={this.onEnterWaypoint} />
            </section>
        );
    }
}

export {
    BookSection,
};
export default localize(BookSection, ['t'], 'baseApp');
